/**
 * 判断值是否为函数
 * @return 是否为函数
 */
export default function isFunction(value) {
    return typeof value === 'function';
}
//# sourceMappingURL=is-function.js.map